import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const PrivacyPolicy = () => {
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      margin: 0,
      padding: 0,
      lineHeight: '1.6'
    }}>
      <Navbar />
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #1a0b3d 0%, #2d1b69 25%, #4a3ba1 50%, #6b5ce7 75%, #8a7ff0 100%)',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}>
        
        {/* Background Decorative Elements */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at 15% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 85% 75%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 25% 85%, rgba(255, 255, 255, 0.08) 0%, transparent 40%)
          `,
          zIndex: 1
        }} />
        
        <div style={{
          position: 'relative',
          zIndex: 2,
          maxWidth: '900px',
          padding: '0 20px'
        }}>
          
          {/* Breadcrumb */}
          <div style={{
            fontSize: '14px',
            color: 'rgba(255, 255, 255, 0.7)',
            marginBottom: '20px'
          }}>
            <span>Home</span> → <span>Legal</span> → <span style={{ color: 'white' }}>Privacy Policy</span>
          </div>
          
          <h1 style={{
            fontSize: '56px',
            fontWeight: '700',
            margin: '0 0 20px 0',
            lineHeight: '1.1',
            letterSpacing: '-2px'
          }}>
            Privacy Policy
          </h1>
          
          <p style={{
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.9)',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.5'
          }}>
            Your privacy is important to us. This policy explains how Global AI Society collects, uses, and protects your personal information.
          </p>
          
          <div style={{
            fontSize: '14px',
            color: 'rgba(255, 255, 255, 0.7)',
            marginTop: '30px'
          }}>
            <strong>Last updated:</strong> July 31, 2025
          </div>
        </div>
      </div>

      {/* Privacy Policy Content */}
      <div style={{
        backgroundColor: 'white',
        padding: '80px 20px'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          
          {/* Table of Contents */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '30px',
            borderRadius: '12px',
            marginBottom: '60px',
            border: '1px solid #e9ecef'
          }}>
            <h3 style={{
              fontSize: '20px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px'
            }}>
              Table of Contents
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '12px'
            }}>
              {[
                '1. Information We Collect',
                '2. How We Use Your Information',
                '3. Information Sharing',
                '4. Data Security',
                '5. Your Rights',
                '6. Cookies and Tracking',
                '7. International Transfers',
                '8. Contact Information'
              ].map((item, index) => (
                <div key={index} style={{
                  padding: '8px 0',
                  fontSize: '14px',
                  color: '#2d1b69',
                  cursor: 'pointer',
                  transition: 'color 0.3s ease'
                }}>
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* Section 1 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              1. Information We Collect
            </h2>
            
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '15px'
              }}>
                Personal Information
              </h3>
              <p style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.8',
                marginBottom: '15px'
              }}>
                We collect information you provide directly to us, including:
              </p>
              <ul style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.8',
                paddingLeft: '25px'
              }}>
                <li>Name and contact information (email, phone number)</li>
                <li>Educational background and professional experience</li>
                <li>Course enrollment and progress data</li>
                <li>Payment and billing information</li>
                <li>Communication preferences</li>
              </ul>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '15px'
              }}>
                Automatically Collected Information
              </h3>
              <ul style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.8',
                paddingLeft: '25px'
              }}>
                <li>Device and browser information</li>
                <li>IP address and location data</li>
                <li>Usage patterns and interaction data</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </div>
          </div>

          {/* Section 2 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              2. How We Use Your Information
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '20px'
            }}>
              We use the information we collect for various purposes, including:
            </p>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '25px',
              marginBottom: '30px'
            }}>
              {[
                {
                  icon: '🎓',
                  title: 'Educational Services',
                  desc: 'Provide courses, certifications, and educational content'
                },
                {
                  icon: '📧',
                  title: 'Communications',
                  desc: 'Send updates, newsletters, and important notifications'
                },
                {
                  icon: '🔧',
                  title: 'Platform Improvement',
                  desc: 'Analyze usage to enhance user experience and functionality'
                },
                {
                  icon: '🤝',
                  title: 'Partnership Services',
                  desc: 'Facilitate partnerships and collaboration opportunities'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  padding: '20px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  textAlign: 'center'
                }}>
                  <div style={{
                    fontSize: '32px',
                    marginBottom: '15px'
                  }}>
                    {item.icon}
                  </div>
                  <h4 style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#2d1b69',
                    marginBottom: '10px'
                  }}>
                    {item.title}
                  </h4>
                  <p style={{
                    fontSize: '14px',
                    color: '#666',
                    lineHeight: '1.6'
                  }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Section 3 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              3. Information Sharing
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '20px'
            }}>
              We do not sell your personal information. We may share your information in the following circumstances:
            </p>
            
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '25px',
              borderRadius: '12px',
              marginBottom: '25px'
            }}>
              <h4 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#2d1b69',
                marginBottom: '15px'
              }}>
                With Your Consent
              </h4>
              <p style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.8'
              }}>
                We share information when you explicitly consent, such as connecting with partnership opportunities or joining collaborative projects.
              </p>
            </div>

            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '25px',
              borderRadius: '12px',
              marginBottom: '25px'
            }}>
              <h4 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#2d1b69',
                marginBottom: '15px'
              }}>
                Service Providers
              </h4>
              <p style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.8'
              }}>
                We work with trusted third-party service providers who help us operate our platform, process payments, and deliver services.
              </p>
            </div>

            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '25px',
              borderRadius: '12px'
            }}>
              <h4 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#2d1b69',
                marginBottom: '15px'
              }}>
              Legal Requirements
              </h4>
              <p style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.8'
              }}>
                We may disclose information when required by law or to protect our rights, safety, and the safety of others.
              </p>
            </div>
          </div>

          {/* Section 4 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              4. Data Security
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '25px'
            }}>
              We implement appropriate technical and organizational measures to protect your personal information:
            </p>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px'
            }}>
              {[
                { icon: '🔒', text: 'SSL/TLS encryption for data transmission' },
                { icon: '🛡️', text: 'Regular security audits and monitoring' },
                { icon: '🔐', text: 'Access controls and authentication' },
                { icon: '💾', text: 'Secure data storage and backups' }
              ].map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '24px' }}>{item.icon}</div>
                  <span style={{
                    fontSize: '14px',
                    color: '#666',
                    lineHeight: '1.5'
                  }}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Section 5 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              5. Your Rights
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '25px'
            }}>
              You have the following rights regarding your personal information:
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '15px'
            }}>
              {[
                'Access: Request a copy of your personal data',
                'Rectification: Correct inaccurate or incomplete information',
                'Erasure: Request deletion of your personal data',
                'Portability: Receive your data in a structured format',
                'Restriction: Limit how we process your information',
                'Objection: Object to processing based on legitimate interests'
              ].map((right, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px'
                }}>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    backgroundColor: '#2d1b69',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    color: 'white',
                    marginTop: '2px',
                    flexShrink: 0
                  }}>
                    ✓
                  </div>
                  <span style={{
                    fontSize: '16px',
                    color: '#666',
                    lineHeight: '1.6'
                  }}>
                    {right}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Section 6 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              6. Cookies and Tracking
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '25px'
            }}>
              We use cookies and similar technologies to enhance your experience:
            </p>
            
            <div style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffeaa7',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '25px'
            }}>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#856404',
                marginBottom: '10px'
              }}>
                Cookie Notice
              </h4>
              <p style={{
                fontSize: '14px',
                color: '#856404',
                lineHeight: '1.6'
              }}>
                By using our website, you consent to our use of cookies as described in this policy. You can manage your cookie preferences through your browser settings.
              </p>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '20px'
            }}>
              {[
                { type: 'Essential', desc: 'Required for basic functionality' },
                { type: 'Analytics', desc: 'Help us understand usage patterns' },
                { type: 'Functional', desc: 'Remember your preferences' },
                { type: 'Marketing', desc: 'Personalize content and ads' }
              ].map((cookie, index) => (
                <div key={index} style={{
                  padding: '20px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <h4 style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#2d1b69',
                    marginBottom: '10px'
                  }}>
                    {cookie.type}
                  </h4>
                  <p style={{
                    fontSize: '14px',
                    color: '#666',
                    lineHeight: '1.5'
                  }}>
                    {cookie.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Section 7 */}
          <div style={{ marginBottom: '50px' }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2d1b69',
              marginBottom: '20px',
              borderBottom: '3px solid #8a7ff0',
              paddingBottom: '10px'
            }}>
              7. International Transfers
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '20px'
            }}>
              As a global organization, we may transfer your information to countries outside your residence. We ensure appropriate safeguards are in place:
            </p>
            
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.8',
              paddingLeft: '25px'
            }}>
              <li>Adequacy decisions by relevant authorities</li>
              <li>Standard contractual clauses</li>
              <li>Binding corporate rules</li>
              <li>Certification schemes and codes of conduct</li>
            </ul>
          </div>

          {/* Contact Section */}
          <div style={{
            backgroundColor: '#2d1b69',
            color: 'white',
            padding: '40px',
            borderRadius: '16px',
            textAlign: 'center'
          }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              marginBottom: '20px'
            }}>
              8. Contact Information
            </h2>
            
            <p style={{
              fontSize: '16px',
              lineHeight: '1.8',
              marginBottom: '30px',
              opacity: 0.9
            }}>
              If you have questions about this Privacy Policy or want to exercise your rights, please contact us:
            </p>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '30px',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              <div>
                <div style={{
                  fontSize: '20px',
                  marginBottom: '10px'
                }}>
                  📧
                </div>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  marginBottom: '5px'
                }}>
                  Email
                </h4>
                <p style={{
                  fontSize: '14px',
                  opacity: 0.8
                }}>
                  privacy@globalaisociety.org
                </p>
              </div>
              
              <div>
                <div style={{
                  fontSize: '20px',
                  marginBottom: '10px'
                }}>
                  📍
                </div>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  marginBottom: '5px'
                }}>
                  Address
                </h4>
                <p style={{
                  fontSize: '14px',
                  opacity: '0.8'
                }}>
                  Global AI Society<br />
                </p>
              </div>
            </div>
          </div>

          {/* Last Updated */}
          <div style={{
            textAlign: 'center',
            marginTop: '40px',
            padding: '20px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px'
          }}>
            <p style={{
              fontSize: '14px',
              color: '#666',
              margin: 0
            }}>
              This Privacy Policy was last updated on <strong>July 31, 2025</strong>. We may update this policy from time to time. We will notify you of any significant changes by posting the new policy on our website.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
